import type { ReactNode, FC } from 'react';
import classnames from 'classnames';
import s from './SectionEmptyState.scss';

interface Props {
  className?: string;
  title?: string;
  body?: ReactNode;
}

const SectionEmptyState: FC<Props> = ({ className, title, body }) => {
  return (
    <div className={classnames(s['root'], className)}>
      <h2 className={s['title']}>{title}</h2>
      <p className={s['body']}>{body}</p>
    </div>
  );
};
SectionEmptyState.displayName = 'SectionEmptyState';

export default SectionEmptyState;
